module.exports = __webpack_public_path__ + "img/EY.cefe2a93.png";